import React, { FC } from 'react';
import { APIS } from '../../../lib/constants/apis';
import AntragRightSidebarBottomIcons from './right-side-bar/AntragRightSidebarBottomIcons';

const OnlineAntragRightSideBarBottomIcons: FC<{ api: string }> = ({ api }) => {
	const RenderSidebar = () => {
		if (api === APIS.Antrag || api === APIS.Verwendungsnachweis) {
			return <AntragRightSidebarBottomIcons />;
		}
		return <></>;
	};

	return <RenderSidebar />;
};

export default OnlineAntragRightSideBarBottomIcons;
